import { useState, useCallback } from 'react';
import type { ChatState } from '@pullman/shared';

export function useChatState() {
  const [chatState, setChatState] = useState<ChatState>('landing');

  const transitionTo = useCallback((next: ChatState) => {
    setChatState(next);
  }, []);

  const activateChat = useCallback(() => {
    setChatState('active');
  }, []);

  return { chatState, setChatState: transitionTo, activateChat };
}
